import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { episodes, hotTags } from "@/lib/content";

export default function HomeSidebar() {
  const infoRows = [
    { label: "导演", value: siteInfo.director },
    { label: "编剧", value: siteInfo.screenwriter },
    { label: "年份", value: siteInfo.year },
    { label: "地区", value: siteInfo.region },
    { label: "类型", value: siteInfo.genre },
  ];
  const recommend = episodes.slice(12, 16).reverse();
  const progress = Math.round((siteInfo.updatedTo / siteInfo.episodeCount) * 100);

  return (
    <aside className="flex flex-col gap-6">
      <section className="rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="flex items-center gap-4">
          <div className="h-[104px] w-[78px] flex-shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={episodes[0].cover}
              alt={`出轨同学会电视剧封面`}
              title="出轨同学会电视剧封面"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="min-w-0">
            <h3 className="font-heading text-lg font-bold text-foreground-900">{siteInfo.brand}</h3>
            <p className="mt-1 font-label text-xs text-foreground-500">
              {siteInfo.year} · {siteInfo.genre}
            </p>
            <div className="mt-2 flex items-center gap-1.5">
              <span className="font-heading text-xl font-bold text-accent-600">{siteInfo.rating}</span>
              <span className="font-label text-[11px] text-foreground-500">分 · 观众评分</span>
            </div>
          </div>
        </div>

        <dl className="mt-5 grid grid-cols-2 gap-x-4 gap-y-3 border-t border-background-200 pt-4">
          {infoRows.map((row) => (
            <div key={row.label} className="flex flex-col">
              <dt className="font-label text-[11px] text-foreground-400">{row.label}</dt>
              <dd className="mt-0.5 truncate font-label text-sm text-foreground-800">{row.value}</dd>
            </div>
          ))}
        </dl>

        <div className="mt-5 border-t border-background-200 pt-4">
          <div className="flex items-center justify-between font-label text-xs text-foreground-500">
            <span>更新进度</span>
            <span className="text-foreground-800">
              更新至第 {siteInfo.updatedTo} 集 / 全 {siteInfo.episodeCount} 集
            </span>
          </div>
          <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
            <div className="h-full rounded-full bg-accent-500" style={{ width: `${progress}%` }}></div>
          </div>
        </div>

        <Link
          to="/detail/ep-16"
          className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-700 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-800"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-play-circle-line text-base leading-none"></i>
          </span>
          查看最新一集
        </Link>
      </section>

      <section className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-900">热门标签</h3>
        <div className="mt-4 flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
            >
              {tag}
            </Link>
          ))}
        </div>
      </section>

      <section className="rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <h3 className="font-heading text-base font-semibold text-foreground-900">追剧推荐</h3>
          <Link to="/category/updates" className="font-label text-xs text-primary-700 hover:text-accent-600">
            全部剧集
          </Link>
        </div>
        <ul className="mt-4 flex flex-col gap-4">
          {recommend.map((episode) => (
            <li key={episode.id}>
              <Link to={`/detail/${episode.id}`} className="group flex items-center gap-3">
                <div className="h-[52px] w-[92px] flex-shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={episode.cover}
                    alt={`出轨同学会第${episode.number}集剧照`}
                    title={`出轨同学会第${episode.number}集 ${episode.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0">
                  <p className="truncate font-label text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
                    第 {episode.number} 集 · {episode.title}
                  </p>
                  <p className="mt-0.5 font-label text-[11px] text-foreground-400">{episode.airDate}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </aside>
  );
}